(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-b2b-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var form = document.getElementById('kx-b2b-form');
    if (!form) return;

    // 把浏览器原生 "请填写此字段" / "请在电子邮件地址中包含 @" 替换成英文
    var validationMessages = {
      valueMissing: 'Please fill out this field.',
      typeMismatch: {
        email: 'Please enter a valid email address (e.g., name@company.com).',
        tel: 'Please enter a valid phone number.'
      },
      default: 'Please check this field.'
    };

    function applyCustomValidation(field) {
      // input 时清掉旧的报错
      field.addEventListener('input', function () {
        field.setCustomValidity('');
      });
      // 当浏览器认为字段无效时(比如点击提交、blur)覆盖文案
      field.addEventListener('invalid', function () {
        if (field.validity.valueMissing) {
          field.setCustomValidity(validationMessages.valueMissing);
        } else if (field.validity.typeMismatch) {
          var msg = validationMessages.typeMismatch[field.type] || validationMessages.default;
          field.setCustomValidity(msg);
        } else {
          field.setCustomValidity(validationMessages.default);
        }
      });
    }

    form.querySelectorAll('input, select, textarea').forEach(applyCustomValidation);

    var typeSelect = document.getElementById('kx-request-type');
    var submitBtn = form.querySelector('.kx-form__submit');

    // 1. 监听卡片预填事件 (来自 contact-intent-cards section)
    var typeMap = {
      buy: '',
      volume: 'Volume Orders & Integration',
      support: 'Technical Support',
      oem: 'OEM / Module Project'
    };
    document.addEventListener('kx:prefill-request-type', function (e) {
      var type = e.detail && e.detail.type;
      if (type && typeMap[type] && typeSelect) {
        typeSelect.value = typeMap[type];
      }
    });

    // 2. URL 参数预填 (兼容外部链接如 /pages/contact?type=volume)
    try {
      var params = new URLSearchParams(window.location.search);
      var qType = params.get('type');
      if (qType && typeMap[qType] && typeSelect && !typeSelect.value) {
        typeSelect.value = typeMap[qType];
      }
    } catch (err) { /* IE / 老浏览器忽略 */ }

    // 4. 表单提交: 加载态 + GA4 事件 (用 sendBeacon/fetch 避免事件丢失)
    form.addEventListener('submit', function (e) {
      // 触发 GA4 事件 (在表单跳转前)
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'contact_form_submit', {
          type: typeSelect ? typeSelect.value : 'unknown',
          product: (document.getElementById('kx-product') || {}).value || '',
          application: (document.getElementById('kx-application') || {}).value || ''
        });
      }

      // === 自动回复: 通过 Zapier webhook 触发 (不阻塞 Shopify 原生提交) ===
      // 设置方法: Zapier 创建 Catch Hook trigger, 复制 webhook URL 替换下方
      // 如果 webhookUrl 留空,这一段不执行,不影响表单正常工作
      var webhookUrl = ''; // ← 替换成 Zapier 的 Catch Hook URL,例如 https://hooks.zapier.com/hooks/catch/xxx/yyy/
      if (webhookUrl) {
        try {
          var emailField = document.getElementById('kx-email');
          var nameField = document.getElementById('kx-name');
          var companyField = document.getElementById('kx-company');
          var payload = {
            email: emailField ? emailField.value : '',
            name: nameField ? nameField.value : '',
            company: companyField ? companyField.value : '',
            request_type: typeSelect ? typeSelect.value : '',
            product_interest: (document.getElementById('kx-product') || {}).value || '',
            application: (document.getElementById('kx-application') || {}).value || '',
            quantity: (document.getElementById('kx-quantity') || {}).value || '',
            stage: (document.getElementById('kx-stage') || {}).value || '',
            submitted_at: new Date().toISOString()
          };
          if (navigator.sendBeacon) {
            var blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
            navigator.sendBeacon(webhookUrl, blob);
          } else {
            fetch(webhookUrl, {
              method: 'POST',
              body: JSON.stringify(payload),
              headers: { 'Content-Type': 'application/json' },
              keepalive: true
            }).catch(function () {});
          }
        } catch (err) { /* webhook 失败不阻塞 Shopify 原生表单提交 */ }
      }
      // === 自动回复结束 ===

      // 设置 loading 状态
      if (submitBtn) {
        submitBtn.classList.add('is-loading');
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.dataset.loadingLabel || 'Sending...';
      }
    });

    // 5. 如果服务端返回成功(form.posted_successfully?),平滑滚动到成功提示
    if (document.querySelector('.kx-form__success')) {
      setTimeout(function () {
        var el = document.getElementById('contact-form');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }

    // 6. 锚点跳转兼容: 如果 hash 是 #contact-form 但页面刚加载,平滑滚动
    if (window.location.hash === '#contact-form') {
      setTimeout(function () {
        var el = document.getElementById('contact-form');
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-direct"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('a[data-email]').forEach(function (a) {
      a.addEventListener('click', function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'email_click', {
            email: this.dataset.email,
            source: 'contact_page'
          });
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-intent-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // 1. GA4: 卡片点击事件
    document.querySelectorAll('.kx-intent__card[data-intent]').forEach(function (el) {
      el.addEventListener('click', function () {
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'contact_intent_click', { intent: this.dataset.intent });
        }
      });
    });

    // 2. 卡片预填表单 Request Type (锚点 #contact-form 自然滚动 + 通过自定义事件传值)
    document.querySelectorAll('.kx-intent__card[data-prefill-type]').forEach(function (el) {
      el.addEventListener('click', function () {
        var type = this.dataset.prefillType;
        // 派发全局事件,由 contact-b2b-form 的 JS 监听并赋值
        document.dispatchEvent(new CustomEvent('kx:prefill-request-type', { detail: { type: type } }));
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
